import type { BundleQualityCheckPayload } from "@/pages/sawlines/repositories/sawWriteRepository";
import type { SawShiftBundle } from "@/pages/sawlines/repositories/sawBundlesRepository";
import {
	type MeasurementValues,
	toCheckFields,
	toNumber,
} from "@/pages/sawlines/utils/qualityCheckMeasurements";
import { toFraction32 } from "@/utils/fraction";

export const cutLabel = (cut: SawShiftBundle) => `Bundle ${cut.ShiftSeq}`;

export const qualityCheckPayload = (
	cut: SawShiftBundle,
	values: MeasurementValues,
): BundleQualityCheckPayload => ({
	assetId: cut.AssetId,
	bundleId: cut.BundleId,
	qualityCheckId: cut.QualityCheckId,
	keepTimestamp: cut.QualityCheckId != null,
	...toCheckFields(values),
});

// 1/16 … 15/16, reduced (2/16 → 1/8)
export const FRACTIONS = Array.from({ length: 15 }, (_, i) =>
	toFraction32(1 + (i + 1) / 16).slice(2, -1),
);

// Keypad key → next text of the point; null = key ignored. `fresh` = first key
// since the point was picked: digits start over instead of appending.
export const typeKey = (
	text: string,
	key: string,
	fresh: boolean,
): string | null => {
	const whole = /^\d+/.exec(text)?.[0] ?? "";
	if (key === "Clear") return "";
	if (key === "Backspace")
		return text.includes("/") ? whole : text.slice(0, -1);
	if (key === "-1/32" || key === "+1/32") {
		const value = toNumber(text);
		const t =
			value == null ? -1 : Math.round(value * 32) + (key[0] === "-" ? -1 : 1);
		return t < 0 ? null : toFraction32(t / 32).slice(0, -1);
	}
	if (key.includes("/")) return whole === "" ? null : `${whole}-${key}`;
	const next = (fresh || text.includes("/") ? "" : text) + key;
	return /^\d{0,3}(\.\d{0,2})?$/.test(next) ? next : null;
};
